import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Självhostade typsnitt i stället för Google Fonts — inga anrop till Googles
// servrar, så besökarens IP skickas inte dit innan samtycke.
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/outfit/500.css'
import '@fontsource/outfit/600.css'
import '@fontsource/outfit/700.css'
import '@fontsource/outfit/800.css'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
